import { autoinject, children } from 'aurelia-framework';

import { BaseViewModel } from '~/base-view-model';
import { TabbedPanel } from './tabbed-panel';

@autoinject
export class TabbedPanels extends BaseViewModel {
	@children('tabbed-panel')
	public tabs: TabbedPanel[];

	/**
	 * Called by the View when a tab is clicked.
	 * @param selectedTab The tab that was clicked.
	 * @private
	 */
	private onClickTab(selectedTab: TabbedPanel) {
		this.tabs.forEach((tab) => {
			tab.selected = false;
		});
		selectedTab.selected = true;
	}

	/**
	 * Select the next tab. If the last tab or no tab is selected, select the first tab.
	 */
	public selectNextTab() {
		const numTabs = this.tabs.length;
		const selectedTabIndex = this.tabs.findIndex((tab) => tab.selected);
		const nextTabIndex = (selectedTabIndex + 1) % numTabs; // no selected tab will select first tab
		if (selectedTabIndex !== -1) {
			this.tabs[selectedTabIndex].selected = false;
		}
		this.tabs[nextTabIndex].selected = true;
	}
}
